// Simple schema versioning & migration for localStorage keys
export interface SchemaEntry { version: number; migrate?: (old:any)=>any; validate?: (val:any)=>boolean; }

const schemas: Record<string, SchemaEntry> = {
  'yatzy-sound-settings': { version: 1, validate: v => v && typeof v === 'object' && 'enabled' in v },
  'yatzy-theme': { version: 1, validate: v => typeof v === 'string' },
  'yatzy-tooltips': { version: 1, validate: v => typeof v === 'object' },
  // Example future bumpable key
  'yatzy-prefs': { version: 1, validate: v => !v || typeof v === 'object' }
};

const META_KEY = 'yatzy-schema-meta';
interface Meta { versions: Record<string, number>; }

function loadMeta(): Meta { try { return JSON.parse(localStorage.getItem(META_KEY)||'') as Meta; } catch { return { versions:{} }; } }
function saveMeta(m:Meta){ try { localStorage.setItem(META_KEY, JSON.stringify(m)); } catch {} }

export function ensureSchemas(){
  const meta = loadMeta();
  Object.entries(schemas).forEach(([key, schema]) => {
    try {
      const raw = localStorage.getItem(key);
      if(raw==null){ meta.versions[key] = schema.version; return; }
      let val:any; try { val = JSON.parse(raw); } catch { localStorage.removeItem(key); return; }
      const currentVersion = meta.versions[key] || 0;
      // If upgrading version and migration exists, run migration BEFORE validating new shape
      if(currentVersion < schema.version && schema.migrate){
        try {
          val = schema.migrate(val);
          localStorage.setItem(key, JSON.stringify(val));
        } catch { /* ignore migrate failure */ }
      }
      if(!schema.validate || !schema.validate(val)){
        localStorage.removeItem(key); meta.versions[key] = schema.version; return;
      }
      meta.versions[key] = schema.version;
    } catch {/* ignore */}
  });
  saveMeta(meta);
}

// Allow registering new schema entries (e.g., during migrations in tests)
export function registerSchema(key: string, entry: SchemaEntry){
  (schemas as any)[key] = entry;
}
